import React, { useState } from 'react';
import { Text } from 'react-native';
import { Flex } from '@kibt/meta-ui-krn';
import LinearGradient from 'react-native-linear-gradient';
import { $k18n } from '@/common/i18n';
import { useCountDown } from 'ahooks';
import { withZeroText } from '@/common/utils/withZeroText';
function BillionSubsidyPure(props: { leftTime: number; onEnd?: () => void }) {
    const { leftTime, onEnd } = props;
    const [isEnd, setIsEnd] = useState(false);
    const [_, formateRes] = useCountDown({
        leftTime, // 设置倒计时总时间
        interval: 1000,
        onEnd: () => {
            onEnd?.();
            setIsEnd(true);
        },
    });

    if (isEnd) return null;

    const countDownText = [formateRes.days, withZeroText(formateRes.hours), withZeroText(formateRes.minutes), withZeroText(formateRes.seconds)]
        .filter(Boolean)
        .join(':');
    return (
        <LinearGradient
            style={{ width: '100%', paddingHorizontal: 8, paddingVertical: 5.5 }}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 0 }}
            colors={['#EED3FF', '#C0F0FF']}
        >
            <Flex flex={'flexRowBtw'}>
                <Text style={{ fontSize: 11, fontWeight: '500', color: '#4101BD' }}>{$k18n({ id: 'k_513882', text: '百万补贴' })}</Text>
                <Text style={{ fontSize: 11, fontWeight: '500', color: '#4101BD' }}>{countDownText}</Text>
            </Flex>
        </LinearGradient>
    );
}
export function BillionSubsidyText() {
    return (
        <LinearGradient
            style={{ width: '100%', paddingHorizontal: 8, paddingVertical: 5.5 }}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 0 }}
            colors={['#EED3FF', '#C0F0FF']}
        >
            <Flex flex={'flexCenter'}>
                <Text style={{ fontSize: 11, fontWeight: '500', color: '#4101BD' }}>{$k18n({ id: 'k_513882', text: '百万补贴' })}</Text>
            </Flex>
        </LinearGradient>
    );
}

export const BillionSubsidy = React.memo(BillionSubsidyPure);
